import { useAtom } from "jotai";

import { listAtom, listFilterAtom } from "../store/statement";

export const useStatement = () => {
  const [list, listSet] = useAtom(listAtom);
  const [listFilter, listFilterSet] = useAtom(listFilterAtom);

  return {
    list,
    listSet,
    listFilter,
    listFilterSet,
  };
};